import { LoadingScreen } from '@/shared/components'
import useI18n from '@/shared/hooks/usei18n'
import { useSession } from '@/shared/hooks/useSession'
import { useGetOrganizationUsers, OrganizationUser } from '@/features/organization/hooks/users'
import { Table, TableColumnHeader, TableRow, TableCell, Button } from '@/common'

export default function UserManagementList({
  users,
  handleEditPermissions,
  isSessionUserAdmin
}: {
  users: OrganizationUser[]
  onEditPermissions: (user: OrganizationUser) => void
  handleEditPermissions: (user: OrganizationUser) => void
  isSessionUserAdmin: boolean
}) {
  const { session } = useSession()
  const { t } = useI18n()

  const organizationId = session.organization.id
  const usersQuery = useGetOrganizationUsers(organizationId)

  const isLoadingUsers = usersQuery.isLoading
  if (isLoadingUsers) {
    return <LoadingScreen />
  }

  return (
    <div className="overflow-x-auto w-full">
      <Table className="table-fixed">
        <thead>
          <TableRow>
            <TableColumnHeader className="w-48">
              {t('userManagement:usersTable.headers.name')}
            </TableColumnHeader>
            <TableColumnHeader className="w-36">
              {t('userManagement:usersTable.headers.role')}
            </TableColumnHeader>
            <TableColumnHeader className="w-36">
              {t('userManagement:usersTable.headers.declarantAccess')}
            </TableColumnHeader>
            {isSessionUserAdmin && <TableColumnHeader className="w-36" />}
          </TableRow>
        </thead>
        <tbody>
          {users.map(user => (
            <TableRow key={user.id}>
              <TableCell>
                {user.firstName} {user.lastName}
              </TableCell>
              <TableCell>{t(`common:roles.${user.role}`)}</TableCell>
              <TableCell>
                {user.role === 'ADMIN'
                  ? t('userManagement:usersTable.declarantAccess.all')
                  : (user.declarants || []).map(declarant => declarant.name).join(', ')}
              </TableCell>
              {isSessionUserAdmin && (
                <TableCell align="right">
                  <Button
                    variant="txt-default"
                    sizeType="sm"
                    disabled={user.role === 'ADMIN'}
                    onClick={() => handleEditPermissions(user)}
                  >
                    {t('userManagement:usersTable.actions.editPermissions')}
                  </Button>
                </TableCell>
              )}
            </TableRow>
          ))}
        </tbody>
      </Table>
    </div>
  )
}
